
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loanAvailableForPromoRenegotiate"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanAvailableForPromoRenegotiate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cashPaymentRestAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cashPaymentRealDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installmentPaymentRestAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBureau"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installmentAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portfolioName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lawsuitDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cnpj"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"chargePolicy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"activeDiscount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cashPaymentDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installmentPaymentDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestRateDiscount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"downPaymentPercentAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxInstallmentCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installmentAmounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installmentCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installmentAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downPaymentAmount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"noDiscount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingFullyPayInvoice"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"values"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"setting"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"renegotiatedLawsuitedLoanOnApp"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":993}};
    doc.loc.source = {"body":"query loanAvailableForPromoRenegotiate {\n  loanAvailableForPromoRenegotiate {\n    id\n    cashPaymentRestAmount\n    cashPaymentRealDiscount\n    installmentPaymentRestAmount\n    interestRate\n    isBureau\n    installmentAmount\n    portfolioName\n    lawsuitDate\n    business {\n      id\n      cnpj\n      owner {\n        id\n        fullName\n      }\n    }\n    chargePolicy {\n      id\n      activeDiscount {\n        cashPaymentDiscount\n        installmentPaymentDiscount\n        interestRateDiscount\n      }\n      downPaymentPercentAmount\n      maxInstallmentCount\n      installmentAmounts {\n        installmentCount\n        installmentAmount\n        downPaymentAmount\n      }\n      noDiscount\n    }\n    pendingFullyPayInvoice {\n      id\n      amount\n      dueDate\n      url\n    }\n    installments{\n      id\n      values {\n        status {\n          id\n          value\n        }\n      }\n    }\n    portfolio{\n      id\n      setting{\n        id\n        renegotiatedLawsuitedLoanOnApp\n      }\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["loanAvailableForPromoRenegotiate"] = oneQuery(doc, "loanAvailableForPromoRenegotiate");
        
